import React from 'react';

const Footer = () => {
  const date = new Date();
  return (
    <footer>
      Copyright &copy; 2004-{date.getFullYear()}
    </footer>
  )
};

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js